/* eslint-disable react/no-array-index-key */
import React, {  useState } from 'react';
import {
   FormControl, Grid, Checkbox, TextField, Chip, Typography,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import Autocomplete  from '@material-ui/lab/Autocomplete'
import useStyles from './styles';

const SpAplicationModel = ({ models, onSubmitForm, forms }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    modelos: []
  });
  const options = models.map(el => el.Modelo_Aplicacion)
  const onChange = (event, value) => {
    setForm({modelos: value});
  };
  return (
    <form
      className={classes.containerCard}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitForm({...forms, modelos: form.modelos, type: forms.type, fechas: forms.fechas }, true, true);
      }}
    >
      <Grid container spacing={3} alignItems="center" sx={12}>
        <Grid item xs={5}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Autocomplete
              freeSolo
              disableCloseOnSelect
              disableClearable
              multiple
              options={options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Modelos de aplicación'
                  variant="outlined"
                />
              )}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    color="primary"
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={<Typography>{option}</Typography>}
                    {...getTagProps({ index })}
                    style={{ backgroundColor: 'white', margin: '0 6px' }}
                  />
                ))}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2} className={classes.button}>
          <Button type="onSubmit " color="warning" fullWidth>
            Filtrar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SpAplicationModel;
